import React from "react";
import ContactForm from "../ContactFrom/ContactForm";

const Pricing = (props) => {
  return (
    <section
      id="pricing-section"
      className="wpo-pricing-section section-padding"
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12  ">
            <div className="wpo-section-title">
              <h2>Aproveite a oferta especial de lançamento</h2>
              <p class="sub-text-white">
                Junte-se ao grupo de pais e profissionais que estão garantindo o
                método completo com esta condição exclusiva para os primeiros
                compradores.
              </p>
            </div>
          </div>
        </div>
        <div className="wpo-pricing-wrap">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-6 col-12">
              {/* A animação Slide pode ser removida para melhor performance em mobile */}
              <div className="wpo-pricing-item active">
                <div className="wpo-pricing-top">
                  <h2>Kit 500 Atividades + Curso Alfetização Emocional</h2>
                  <div className="pricing-amount">
                    <span className="strikethrough">De R$ 597,00</span>
                    <span className="new-price">Por R$ 97,00</span>
                  </div>
                </div>
                <div className="row ">
                  <div className="col-lg-6 col-md-12">
                    <div className="wpo-pricing-bottom">
                      <ul>
                        <li>Acesso a mais de 500 atividades</li>
                        <li>Download em PDF</li>
                        <li>Suporte por WhatsApp</li>
                        <li>
                          <b>Bônus:</b> Curso de Alfabetização Emocional
                        </li>
                        <li>
                          <b>Bônus:</b> Atividades novas todos meses
                        </li>
                        <li>
                          <b>Bônus:</b> Quadro de Rotinas
                        </li>
                        <li>
                          <b>Bônus:</b> Bobbie Good Versão Cristã
                        </li>
                        <li>
                          <b>Bônus:</b> Jogos de Estimulação Cognitiva
                        </li>
                        <li>
                          <b>Bônus:</b> Planne de Gratidão para Crianças
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div className="wpo-contact-form-area">
                      <p className="form-title">
                        Preencha para garantir seu kit:
                      </p>
                      <ContactForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
